// extracted by mini-css-extract-plugin
module.exports = {"resendOtpButton":"ResendOtp_resendOtpButton__334Y5","resendOtpButtonTimer":"ResendOtp_resendOtpButtonTimer__6EhaH","resendOtpButtonActive":"ResendOtp_resendOtpButtonActive__2r5D0"};